import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _AbstractAccount, _single, _TrainingRequest } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { SelectFunctionalID } from "../../../../../admin/configuracion/functionalID/SelectFunctionalID";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import useModal, { MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Aprove: string;
}

type SignedApprove = {
    IDAccount: number;
    Approved: boolean;
    Date: string;
};

export const SOLCAP002 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};

    const { instance, bean, setBean } = useDataBean(_TrainingRequest);
    const { instance: instanceAcc, lista: listaAcc, setLista: setListaAcc } = useDataBean(_AbstractAccount);
    const modal = useModal("Listado de ususarios", MODAL_md);

    const [response, setResponse] = useState<Resp>({
        Aprove: "",
        Obs: ""
    })

    useEffect(() => {
        if (props?.IDTrainingRequest) {
            instance.getTrainingRequest(props?.IDTrainingRequest).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        } else if (props) {
            setBean(props)
        }
    }, [props?.IDTrainingRequest])

    const getIDAccountValue = (value: any) => {
        return Number(typeof value === "object" ? value?.IDAccount : value);
    }

    const getListIDAccounts = (value: any): number[] => {
        const normalizeIDs = (list: any[]) => {
            return list
                .map(getIDAccountValue)
                .filter((id) => !Number.isNaN(id));
        }

        if (!value) return [];
        if (Array.isArray(value)) return normalizeIDs(value);

        if (typeof value === "string") {
            const cleanValue = value.trim();
            if (!cleanValue) return [];

            try {
                const parsedValue = JSON.parse(cleanValue);
                return Array.isArray(parsedValue) ? normalizeIDs(parsedValue) : [];
            } catch {
                return normalizeIDs(cleanValue.split(",").map((id) => id.trim()));
            }
        }

        return [];
    }

    const getTargetScopeName = (targetScopeType: number) => {
        const scopeType = Number(targetScopeType);

        if (scopeType === 101) return "Area Funcional";
        if (scopeType === 102) return "Usuarios Selectos";
        if (scopeType === 103) return "Unico Usuario";
        return "N/A";
    }

    const getAccountName = (item: any) => {
        const data = item?.DataBeanProperties ?? item;
        const fullName = [
            data?.Name1,
            data?.Name2,
            data?.Surname1,
            data?.Surname2
        ].filter(Boolean).join(" ");

        return fullName
            || data?.AccountFullName
            || data?.EntityName
            || data?.FullName
            || data?.Name
            || data?.EmployeeFullName
            || data?.IDAccount
            || "N/A";
    }

    const onExportMap = () => {
        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Solicitud": `${response.Aprove == "true" ? "Aprobada" : "Rechazada"}`,
                "Jusitificación": response.Obs,
            })
        );
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }
    }


    const updateData = () => {
        if (response.Obs.trim().length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setResponse({ ...response, Aprove: "" })
            return;
        }

        const signedList: SignedApprove[] = JSON.parse(bean.JSONAproveList || "[]");

        const newSign: SignedApprove = {
            IDAccount: _single.getAccountID(),
            Approved: response.Aprove === "true",
            Date: _single.getCurrenDate(),
        };

        signedList.push(newSign);

        const x = {
            ...bean,
            State: response.Aprove == "true" ? 2 : 3,
            JSONApproveList: JSON.stringify(signedList)
        };

        instance.updateTrainingRequest(x).then(
            (resp) => {
                onExportMap();
            }
        ).catch(err => { toast.error("No se pudo realizar la accion") })
    }


    useEffect(() => {
        if (response.Aprove !== "") {
            updateData();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        setResponse(prev => ({ ...prev, Aprove: `${app}` }));
    }

    const getUsers = (e: number[]) => {
        instanceAcc.getAccountsInfoByIds(e).then(
            (resp) => {
                const accounts = resp?.DataBeanProperties?.ObjectValue ?? resp;

                if (Array.isArray(accounts)) {
                    accounts.forEach((item: any) => {
                        const data = item?.DataBeanProperties ?? item;
                        data.AccountFullName = getAccountName(data);
                        data.Nit = data.nit ?? data.Nit;
                        data.Email = data.eMail ?? data.Email;
                    });
                }

                setListaAcc(Array.isArray(accounts) ? accounts : []);
                modal.open();
            }
        ).catch(err => { toast.error(err) })
    }

    const headUsers = [
        { title: 'Documento', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'AccountFullName', visible: true },
        { title: 'Correo', property: 'Email', visible: true },
        { title: 'Telefono', property: 'tel', visible: true, mask: MASK_NUMBER },
    ];

    const listIDAccounts = getListIDAccounts(bean.ListIDAccounts);
    const targetScopeType = Number(bean.TargetScopeType);

    return (
        <div className="container-fluid">
            <div className="card mb-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="fw-bold">Alcance de la Capacitacion</label>
                            <div className="form-control bg-light">{getTargetScopeName(bean.TargetScopeType)}</div>
                        </div>

                        {targetScopeType === 101 &&
                            <div className="col-md-6">
                                <SelectFunctionalID disable={true} label="Area Funcional" functionalIDLn={bean.IDLnFunctionalID} onChange={() => { }} />
                            </div>
                        }

                        {targetScopeType === 102 &&
                            <div className="col-md-6">
                                <label className="fw-bold">Empleados Seleccionados</label>
                                <div className="form-control bg-light text-wrap pointer" onClick={() => { getUsers(listIDAccounts) }} style={{ minHeight: '35px' }}>
                                    {listIDAccounts.length > 0 ? "Ver lista de usuarios" : "N/A"}
                                </div>
                            </div>
                        }

                        {targetScopeType === 103 &&
                            <div className="col-md-6">
                                <AccountEditor disabled={true} idAccount={bean.IDAccount} label="Usuario Seleccionado" onChange={() => { }} />
                            </div>
                        }

                        <div className="col-md-12">
                            <label className="fw-bold">Tematica de la capacitacion</label>
                            <div className="form-control bg-light">{bean.TrainingTopic ?? "N/A"}</div>
                        </div>

                        <div className="col-md-12">
                            <label className="fw-bold">Descripcion de la Capacitacion</label>
                            <div className="form-control bg-light text-wrap" style={{ minHeight: '70px' }}>{bean.Description ?? "N/A"}</div>
                        </div>

                        <div className="col-md-12">
                            <label className="fw-bold">Justificacion</label>
                            <div className="form-control bg-light text-wrap" style={{ minHeight: '70px' }}>{bean.Justification ?? "N/A"}</div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="mb-3">
                <label className="fw-bold">Observaciones</label>
                <textarea
                    className="form-control mt-1"
                    rows={3}
                    value={response.Obs}
                    onChange={(e) =>
                        setResponse(prev => ({ ...prev, Obs: e.target.value }))
                    }
                />
            </div>

            <div className="d-flex justify-content-between mt-4">

                <BasicButton disable={!bean.IDTrainingRequest} icon="ri-checkbox-circle-line" eventClick={() => { updateForm(true) }} >Aprobar</BasicButton>

                <BasicButton disable={!bean.IDTrainingRequest} icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>

            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable body={listaAcc} head={headUsers} rowSet={() => { }} customRows={15} />
            </Modal>
        </div>
    );
}
